/**
 * Dev-only logger. Silent in production builds so error context is preserved
 * during development but doesn't leak to end users via console.
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
    warn: (...args) => {
        if (isDev) console.warn(...args);
    },
    error: (...args) => {
        if (isDev) console.error(...args);
    },
    info: (...args) => {
        if (isDev) console.info(...args);
    },
};
